import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import RentalHistoryDetail from './detail';
import RentalHistoryList from './list';

export default observer(function RentalHistoryTab() {
    const { id } = useParams();

    return (
        <>
            {id ? <RentalHistoryDetail /> : <RentalHistoryList />}
        </>
    );
});
